import { InMemoryCache, NormalizedCacheObject } from 'apollo-cache-inmemory';
import { ApolloClient } from 'apollo-client';
import { ApolloLink, from } from 'apollo-link';
import { createHttpLink } from 'apollo-link-http';
// import { onError } from 'apollo-link-error';
// import { createBrowserHistory } from 'history';

import { graphQLEndpoint } from '../config/config';

// const browserHistory = createBrowserHistory();

export class ApolloClientFactory {
    private static instance: ApolloClient<NormalizedCacheObject>;

    public static GetClient() {
        if (this.instance == undefined) {
            const httpLink = createHttpLink({
                uri: graphQLEndpoint
            });
            
            /*const errorLink = onError(({ graphQLErrors, networkError, operation, forward }) => {
                
                console.log('graphQLErrors', graphQLErrors);
                console.log('networkError', networkError);

                if (graphQLErrors) {
                    graphQLErrors.map(({ message, locations, path }) => {
                        // console.log(
                        //   `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`,
                        // );
                        // "Forbidden resource"
                        if (message === 'Forbidden resource' && localStorage.getItem('token')) {
                            localStorage.removeItem('token');
                            window.location.replace('/');
                            // browserHistory.push('/');
                            return forward(operation);
                        }

                        return forward ? forward(operation) : null;
                    });
                };
              
                // if (networkError) {
                //     console.log(`[Network error]: ${networkError}`);
                // }
            })*/

            const authMiddleware = new ApolloLink((operation, forward) => {
                operation.setContext({
                    headers: {
                        Authorization: localStorage.getItem('token') ? `${localStorage.getItem('token')}` : null
                    }
                });

                return forward ? forward(operation) : null;
            });

            this.instance = new ApolloClient({
                link: from([authMiddleware, /*errorLink, */httpLink]),
                cache: new InMemoryCache(),
                // Apollo Boost allows you to specify a custom error link for your client
            });
        }

        return this.instance;
    }

    private constructor() {}
}



// WEBPACK FOOTER //
// ./src/domain/apolloClientFactory.ts